// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@insite/mobius/FormField";
import { userInformationStyles } from "@rpsc/Overrides/Widgets/AccountSettings/AccountSettingsUserInformation";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

userInformationStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

userInformationStyles.inputsWrapper = {
    css: css`
        display: flex;
        column-gap: 16px;
        flex-wrap: wrap;
        row-gap: 12px;
        > ${FormFieldStyle} {
            width: calc(100% / 3 - 11px);
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        }
    `,
};

userInformationStyles.passwordWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        width: calc(2 / 3 * 100% - 19px);
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
        > ${FormFieldStyle} {
            width: 50%;
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        }
    `,
};

userInformationStyles.userInformationTitle = {
    as: "h2",
    variant: "h4",
};

userInformationStyles.changePasswordLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
        css: css`
            white-space: nowrap;
            padding-top: 18px;
        `,
    },
};
